<script setup>
import { ref, onMounted, computed } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head, useForm } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import Buttons from "@/Components/Buttons.vue";
import {
    mdiHomeSearch, mdiWhatsapp, mdiCashPlus,
    mdiCradle, mdiPuzzleRemove, mdiTownHall, mdiCross, mdiPill, mdiMedicalBag, mdiGymnastics, mdiWater, mdiCheckDecagram, mdiContentSave, mdiAccountSupervisor,
    mdiCreditCardOutline, mdiPlusCircle, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiMail, mdiInformationOutline, mdiPrinter, mdiFileDocumentMultipleOutline,
    mdiCardAccountDetails, mdiGenderMaleFemale, mdiCellphone, mdiEmail, mdiClockTimeFive
} from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import PageHeader from '@/Components/PageHeader.vue';
import { Inertia } from '@inertiajs/inertia';

import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxCiclo from "@/Components/CardBoxCiclo.vue";
import RadarChart from "@/Components/Charts/RadarChart.vue";
import NotificationAlert from "@/Components/NotificationAlert.vue";

/* - LRR defineProps({
    //students: Array,
    //columnas: Array,
    object: Object
});
*/
const props = defineProps({
    //students: Array,
    //columnas: Array,
    actioncontrol: {
        type: String,
        default: 'view'
    },
    object: Object,
    tallas: Object,
    user_modif: Object,
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    back_link: String,
    debugInertia: Boolean,

});

const anioSearch = ref(null)
const rutaPrefijo = ref('product')
const modulo = ref('product')
const modulos = ref('Productos')
const action = ref(props.actioncontrol) // Los props son de lectura así que en el template se haré cambios al action segúnn el click a cada boton

const tab = ref(0)

// deshabilitar o habilitar
const initModal = (action) => {
    let ruta = rutaPrefijo.value + '-' + action
    Inertia.put(route(ruta, {
        'id': props.object.id,
    }
    ))

}

const form = useForm({
    id: props.object ? props.object.id : 0,
    // Producto
    ref: props.object ? props.object.ref : null,
    label: props.object ? props.object.label : null,
    description: props.object ? props.object.description : null,
    price: props.object ? props.object.price : 0,
    price_ttc: props.object ? props.object.price_ttc : 0,
    //price_base_type: props.object ? props.object.price_base_type : '',
    tva_tx: props.object ? props.object.tva_tx : '0.00',
    cost_price: props.object ? props.object.cost_price : 0,
    tosell: props.object ? props.object.tosell : 1,
    tobuy: props.object ? props.object.tobuy : 1,
    id_talla: props.object ? props.object.id_talla : 0,
    stock: props.object ? props.object.stock : 0,
    stock_alerta: props.object ? props.object.stock_alerta : 0

});

const clean = (origen = '') => {

    if (origen == 'product') {
        action.value = 'view'
    }

}

/**
 * 
 * LRR 
 * Incializar valorres
 */

const optionsIgvTasa = [
    { id: '0.00', label: '0' },
    { id: '18.00', label: '18' },
]
const optionsPriceBase = [
    { id: 'HT', label: 'HT' },
    { id: 'HT', label: 'TTC' },
]

const optionsIgvCode = [
    { id: 'GRAV', label: 'GRAV' },
    { id: 'EXO', label: 'EXO' },
    { id: 'INA', label: 'INA' },
]

// Crear o actualizar
const submit = () => {
    if (action.value == 'create') {
        form.post(route(rutaPrefijo.value + '-registrar'), {
            //onFinish: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
            onSuccess: () => form.reset('ref', 'label', 'description', 'price', 'cost_price', 'id_talla'),
        });
    } else {
        form.put(route(rutaPrefijo.value + '-actualizar'), {
            onFinish: () => {
                form.reset('ref, label, description, price, cost_price, id_talla, tosell')
                clean('product')
            },
            onError: () => window.Toast.error(errors.create)
        });
    }

};


const formatDate = (date) => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    return result
}

//console.log(props.object)
const formatDateTime = (datetime) => {
    var date = new Date(datetime)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
    return result
}



/**
 * Section Alert
 */

const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message, color, time = 1) => {

    messageAlert.value = message
    colorAlert.value = color

    isAlertActive.value = true

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

/**
 * Procesar archivos adjuntos
 */
const arrayDocumentos = ref([]);
const arrayDocumentosCol = ref([]);
const listarDocumentos = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/document/file_document_product?src_object_id=' + props.object.id;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayDocumentos.value = respuesta.datalist;
        arrayDocumentosCol.value = respuesta.columnas;
        console.log(arrayDocumentos.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const inputFileName = ref('')
const inputFileDesc = ref('')
const inputFilePos = ref(1)
const showInputFile = ref(false)
const fileDocument = ref(null)
const fileSize = ref(0)
const changeFile = (type) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    let file = null;
    if (type == 'file_document_product') {
        file = fileDocument.value.files[0];
    }

    //console.log(file);
    console.log(file.size);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (file) {
        fileSize.value = file.size
        if (file.name.includes('.jpg') || file.name.includes('.png')) {
            console.log('Es imagen')
        } else {
            console.log('No es imagen jpg o png')
        }
    }

}

const uploadFile = (type, origin_id = 0) => {
    let data = new FormData()
    let file = null;
    if (type == 'file_document_product') {
        file = fileDocument.value.files[0];
        origin_id = props.object.id
    }
    data.append('file', file)
    data.append('origin_type', type)

    // Se puede agregar otro origin id si fuera necesario
    data.append('origin_id', origin_id)

    data.append('name', inputFileName.value)
    data.append('description', inputFileDesc.value)
    data.append('position', inputFilePos.value)
    console.log(file)
    axios.post('/file/upload', data)
        .then(response => {

            if (response.data.error) {
                showAlert(response.data.message, 'danger', 5)
                if (type == 'file_document_product') {
                    errorMessage.value == response.data.message
                }
            } else if (response.data.success) {
                showAlert(response.data.message, 'success', 2)
                listarDocumentos()
                cleanInputFile()

            }
            console.log(response.data)
        })
        .catch(error => {
            console.log(error)
        })

}

const cleanInputFile = () => {
    inputFileName.value = ''
    inputFileDesc.value = ''
    inputFilePos.value = 1
    fileDocument.value = null
    fileSize.value = 0
}

const backLink = ref(props.back_link ? '/#' + props.back_link : '')

onMounted(() => {
    if (props.actioncontrol !== 'create' && props.object) {
        listarDocumentos();
    }
});

const firstImage = computed(() => {
    if (arrayDocumentos.value && arrayDocumentos.value.length > 0) {
        let img = arrayDocumentos.value.find(doc => ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(doc.extension.toLowerCase()));
        if (img) {
            return `/filedw/file_document_product/${props.object.id}/${img.filename}`;
        }
    }
    return '/img/no_image.png';
});

const productTabs = ref([
    { id: 0, label: 'Producto' },
    { id: 1, label: 'Documentos' }
]);

const handleTabChange = (t) => {
    if (t.id === 0) {
        action.value = 'view';
    } else if (t.id === 1) {
        listarDocumentos();
    }
};

</script>

<template>

    <Head :title="object ? object.label : 'Nuevo producto'" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader :tabs="productTabs" v-model="tab" title="" @change="handleTabChange">
                <template #actions>
                    <Link :href="route('product-list')">
                        <Buttons color="primary" size="header" icon="mdi:arrow-u-left-top-bold" label="Volver al Listado" :hideLabelOnMobile="true" />
                    </Link>
                </template>
            </PageHeader>
        </template>

        <div class="py-8 lg:py-10">
            <div class="mx-auto sm:px-6 lg:px-8 px-4">
                <template v-if="(tab == 0)">
                    <template v-if="action == 'view' && object">
                        <div class="grid grid-cols-1 gap-4 bg-white overflow-hidden border shadow-lg rounded-md p-4">
                            <div class="col-span-1">
                                <div class="flex flex-col md:flex-row gap-4 xl:gap-6 h-full">
                                    <div class="h-40 w-40 lg:h-52 lg:w-52 shrink-0 rounded-md border flex items-center justify-center p-2 bg-white">
                                        <img class="max-h-full max-w-full object-contain" :src="firstImage">
                                    </div>
                                    <div class="h-auto w-full">
                                        <div class="flex flex-col justify-start gap-2 w-full">
                                            <div class="text-xl font-semibold mb-2">{{ object.label }}</div>
                                            <div class="w-full">
                                                <div class="font-semibold mb-1">Descripción : </div>
                                                <div v-if="object.description" class="border rounded-md p-4 bg-gray-50 text-gray-700 w-full" v-html="object.description"></div>
                                                <div v-else class="border rounded-md p-4 bg-gray-50 text-gray-500 italic w-full">No se ha agregado aún descripción.</div>
                                            </div>
                                            <div><span class="font-semibold mr-2">Precio sin impuesto : </span> {{ object.price }}<br></div>
                                            <div><span class="font-semibold mr-2">Precio incluido IGV : </span> {{
                                                object.price_ttc
                                            }}, IGV Tasa : {{ object.tva_tx }}<br></div>
                                            <div><span class="font-semibold mr-2">Stock : </span>
                                                {{ object.stock }}</div>
                                            <div><span class="font-semibold mr-2">En Venta : </span>{{ object.tosell ? 'Si' : 'No' }}</div>
                                            <!-- Referencia : {{ object.person.referencia }} -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Botón Modificar integrado -->
                            <div v-if="canWrite" class="flex justify-end mt-4 pt-4 border-t border-gray-100">
                                <Buttons color="yellow" icon="mdi:pencil" @click="action = 'edit'" label="Modificar" />
                            </div>
                        </div>
                    </template>
                    <!-- Editar -->
                    <template v-else-if="action == 'edit' && canWrite">
                        <div class="grid grids-col-1 bg-white overflow-hidden border shadow-lg rounded-md p-4">
                            <h3 class="md:text-2xl text-xl my-4 font-semibold">Modificar</h3>
                            <form @submit.prevent="submit">
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Etiqueta nombre / talla</label>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <input v-model="form.label" name="label" type="text" required class="w-full" />
                                        <select v-model="form.id_talla" class="w-full">
                                            <option v-for="talla in tallas" :key="talla.id ?? talla" :value="talla.id ?? talla">{{ talla.label ?? talla }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Descripción</label>
                                    <div class="grid grid-cols-1 gap-3">
                                        <textarea v-model="form.description" class="w-full h-24"></textarea>
                                    </div>
                                </div>
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Estado</label>
                                    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <select v-model="form.tosell" class="w-full">
                                            <option value="0">No en venta</option>
                                            <option value="1">Si en venta</option>
                                        </select>
                                        <select v-model="form.tobuy" class="w-full">
                                            <option value="0">No en compra</option>
                                            <option value="1">Si en compra</option>
                                        </select>
                                        <input v-model="form.cost_price" type="number" placeholder="Precio de costo" title="Precio de costo" class="w-full" />
                                    </div>
                                </div>
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Precio</label>
                                    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <div>
                                            <div class="text-xs font-semibold text-gray-500 mt-1 mb-1">Precio Sin impuesto</div>
                                            <input v-model="form.price" type="number" :set="(form.price = (form.price_ttc / (1 + (form.tva_tx / 100))))" readonly class="w-full" />
                                        </div>
                                        <div>
                                            <div class="text-xs font-semibold text-gray-500 mt-1 mb-1">Tasa IGV</div>
                                            <select v-model="form.tva_tx" class="w-full">
                                                <option v-for="opt in optionsIgvTasa" :key="opt.id ?? opt" :value="opt.id ?? opt">{{ opt.label ?? opt }}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <div class="text-xs font-semibold text-gray-500 mt-1 mb-1">Precio incluido IGV</div>
                                            <input v-model="form.price_ttc" type="number" class="w-full" />
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Stock</label>
                                    <div class="grid grid-cols-1 gap-3">
                                        <div>
                                            <div class="text-xs font-semibold text-gray-500 mt-1 mb-1">Stock mínimo para alerta</div>
                                            <input v-model="form.stock_alerta" type="number" class="w-full" />
                                        </div>
                                    </div>
                                </div>

                                <div class="flex items-center justify-end mt-4 gap-4">
                                    <Link :href="route('product-list')">
                                        <Buttons color="white" label="Cancelar" />
                                    </Link>
                                    <Buttons color="blue" label="Actualizar" type="submit" :class="{ 'opacity-25': form.processing }" :disabled="form.processing" />
                                </div>
                            </form>
                        </div>
                    </template>
                    <!-- Crear sólo desde el botón return dashboard-->
                    <template v-else-if="action == 'create'">
                        <div class="grid bg-white overflow-hidden border shadow-lg rounded-md p-4">
                            <h3 class="md:text-2xl text-xl my-4 font-semibold">Agregar nuevo producto</h3>
                            <form @submit.prevent="submit">
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Etiqueta nombre / talla</label>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <input v-model="form.label" name="label" type="text" required class="w-full" />
                                        <select v-model="form.id_talla" class="w-full">
                                            <option v-for="talla in tallas" :key="talla.id ?? talla" :value="talla.id ?? talla">{{ talla.label ?? talla }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Descripción</label>
                                    <div class="grid grid-cols-1 gap-3">
                                        <textarea v-model="form.description" class="w-full h-24"></textarea>
                                    </div>
                                </div>
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Estado</label>
                                    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <select v-model="form.tosell" class="w-full">
                                            <option value="0">No en venta</option>
                                            <option value="1">Si en venta</option>
                                        </select>
                                        <select v-model="form.tobuy" class="w-full">
                                            <option value="0">No en compra</option>
                                            <option value="1">Si en compra</option>
                                        </select>
                                        <input v-model="form.cost_price" type="number" placeholder="Precio de costo" title="Precio de costo" class="w-full" />
                                    </div>
                                </div>
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Precio</label>
                                    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <div>
                                            <div class="text-xs font-semibold text-gray-500 mt-1 mb-1">Precio Sin impuesto</div>
                                            <input v-model="form.price" type="number" :set="(form.price = (form.price_ttc / (1 + (form.tva_tx / 100))))" readonly class="w-full" />
                                        </div>
                                        <div>
                                            <div class="text-xs font-semibold text-gray-500 mt-1 mb-1">Tasa IGV</div>
                                            <select v-model="form.tva_tx" class="w-full">
                                                <option v-for="opt in optionsIgvTasa" :key="opt.id ?? opt" :value="opt.id ?? opt">{{ opt.label ?? opt }}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <div class="text-xs font-semibold text-gray-500 mt-1 mb-1">Precio incluido IGV</div>
                                            <input v-model="form.price_ttc" type="number" class="w-full" />
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-6">
                                    <label class="block font-semibold mb-2">Stock</label>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <div>
                                            <div class="text-xs font-semibold text-gray-500 mt-1 mb-1">Stock Inicial</div>
                                            <input v-model="form.stock" type="number" class="w-full" />
                                        </div>
                                        <div>
                                            <div class="text-xs font-semibold text-gray-500 mt-1 mb-1">Stock mínimo para alerta</div>
                                            <input v-model="form.stock_alerta" type="number" class="w-full" />
                                        </div>
                                    </div>
                                </div>

                                <div class="flex items-center justify-end mt-4 gap-4">

                                    <Link :href="route('product-list')">
                                        <Buttons color="white" label="Cancelar" />
                                    </Link>
                                    <span v-if="!form.label" class="ml-3 font-medium text-red-600">Debe registrar una etiqueta o nombre</span>
                                    <span v-else-if="!form.price_ttc && !form.price" class="ml-3 font-medium text-red-600">Debe asignar un precio</span>
                                    <Buttons v-else color="blue" label="Registrar" type="submit" :class="{ 'opacity-25': form.processing }" :disabled="form.processing" />
                                </div>
                            </form>
                        </div>
                    </template>

                </template>

                <!-- Documentos -->
                <template v-else-if="(tab == 1)">
                    <div class="grid grid-cols-1 bg-white overflow-hidden border shadow-lg rounded-md p-4">
                        <div class="col-span-1">
                            <h2 class="mb-3">Documentos adjuntos de {{ object.label }}</h2>
                            <!-- <div v-if="message">{{ message }}</div> -->
                            <div v-if="canWrite" class="">
                                <p class="my-2 text-sm mb-3">
                                    Puede subir archivos PDF, DOCX, PPT, XLSX, JPG,
                                    PNG, con un <b>límite máximo</b> de {{
                                        confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE }}
                                    KB. <b>Si ingresa un nombre que ya existe el documento anterior será reemplazado por este</b>.
                                </p>
                                <div v-if="fileSize > (1000 * parseInt(confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE))" class="mb-4">
                                    <small class="font-medium text-red-600">El archivo
                                        supera
                                        el tamaño límite permitido</small>
                                </div>
                                <div class="mb-4 w-full">
                                    <label for="name" class="text-sm mb-1 font-semibold">Nombre de Archivo </label>
                                    <input id="inputname" type="text" class="mt-1 block w-full" v-model="inputFileName" required />
                                </div>
                                <div class="mb-4">
                                    <label for="desc" class="text-sm mb-1 font-semibold">Descripción (opcional) </label>
                                    <textarea id="inputdesc" type="text" class="mt-1 block w-full h-24" v-model="inputFileDesc" autocomplete="off"> </textarea>
                                </div>
                                <!-- <div>
                                <BreezeLabel for="pos" value="Posición" />
                                <BreezeInput id="inputpos" type="number"
                                    class="mt-1 block" v-model="inputFilePos" />
                                </div> -->
                                <div class="mb-4">
                                    <label>
                                        <input id="file_document_product" ref="fileDocument" type="file" @change="changeFile('file_document_product')" class="w-full" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">
                                    </label>
                                </div>
                                <!-- <label>
                                    <input type="file" id="fileCatalogo" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="w-full input-file input-file-slate" />
                                </label> -->

                                <Buttons icon="mdi:plus-circle" color="blue" label="Guardar" @click="uploadFile('file_document_product')" />
                            </div>
                            <hr class="my-4">
                            <!-- Lista -->
                            <div class="w-full overflow-x-auto relative">
                                <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                                    <!-- Tablesingle opciones: checkable -->
                                    <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file" :deleteable="canDelete ? true : false" originType="file_document_product" :originId="object.id" @reload="listarDocumentos()" />
                                </CardBox>
                                <CardBox v-else>
                                    <CardBoxComponentEmpty />
                                </CardBox>
                            </div>
                        </div>
                    </div>
                </template>

            </div>
        </div>


    </BreezeAuthenticatedLayout>
</template>
